export default __webpack_public_path__ + "static/media/BTSTU KIK1.7f6519cc.wav";